import './style.scss'
import { UiButtonVanilla } from '../../Buttons/UiButton/UiButtonVanilla'
import { UiIconButtonVanilla } from '../../Buttons/UiIconButton/UiIconButtonVanilla'
import { UiTextReviewHeaderVanilla } from './components/UiTextReviewHeader/UiTextReviewHeaderVanilla'

const IconsName = {
  inst: 'instagram',
  'ok-new': 'odnoklassniki',
  fb: 'facebook'
}

const MD_MAX = 1023.9

export class UiTextReviewVanilla {
  constructor(block, UiModal) {
    this.block = block
    this.reviews = block.querySelectorAll('.ui-text-review')

    this.UiModal = UiModal
  }

  getInitials(name) {
    return name.slice(0, 1)
  }

  setInitials(review) {
    const avatar = review?.querySelector('.ui-text-review-header__avatar-wrapper--initials')

    if (avatar) {
      const name = review.querySelector('.ui-text-review-header__author')
      avatar.textContent = this.getInitials(name.textContent.trim())
    }
  }

  showFullComment(review) {
    const commentModalTemplate = this.block.querySelector('#ui-text-reviews-modal')
    const commentModal = commentModalTemplate
      .content
      .cloneNode(true)
      .querySelector('.ui-text-reviews-modal__content')
    const modalHeader = commentModal.querySelector('.ui-text-reviews-modal__header')
    const modalContent = commentModal.querySelector('.ui-text-reviews-modal__text')

    const header = review.querySelector('.ui-text-review-header')
    const content = review.querySelector('.ui-text-review__text')
    const avatar = header?.querySelector('.ui-text-review-header__avatar-wrapper--initials')

    modalHeader.innerHTML = header.innerHTML
    modalContent.innerHTML = content.innerHTML

    if (avatar) {
      const modalAvatar = modalHeader.querySelector('.ui-text-review-header__avatar-wrapper--initials')
      if (modalAvatar) {
        modalAvatar.style.backgroundColor = getComputedStyle(avatar).backgroundColor
      }
    }

    new this.UiModal(commentModal, { wrapperClass: 'ui-text-reviews-modal__wrapper' }).init()
  }

  collapseText(review) {
    const textElement = review.querySelector('.ui-text-review__text')
    const buttonShowMore = review.querySelector('.ui-text-review__show-more')

    if ((window.innerWidth <= MD_MAX && textElement.offsetHeight > 355) || (window.innerWidth > MD_MAX && textElement.offsetHeight > 250)) {
      textElement.classList.add('ui-text-review__text--hidden')
    } else {
      buttonShowMore?.remove()
    }
  }

  clickMoreHandle(el) {
    const review = el.closest('.ui-text-review')
    review && this.showFullComment(review)
  }

  clickShowMoreHandle(evt) {
    const target = evt.target
    const buttonShowMore = target.closest('.ui-text-review__show-more')

    if (buttonShowMore) {
      this.clickMoreHandle(buttonShowMore)
    }
  }

  init() {
    this.reviews.forEach((review) => {
      this.setInitials(review)

      this.collapseText(review)
    })
  }
}

const getUiTextReviewTemplate = ({ data, theme, classes }) => {
  return (
    `<article class="ui-text-review ui-text-review--${theme} ${classes}">
      ${UiTextReviewHeaderVanilla({ data, classes: 'ui-text-review__header' })}

      <div class="ui-text-review__content">
        <div class="ui-text-review__text p p--2">
          ${data.review}
        </div>

        <button class="ui-text-review__show-more f f--16">
          <svg
            class="ui-text-review__show-more-icon"
            width="20"
            height="20"
            aria-hidden="true"
          >
            <use href="#ui-more-horizontal" />
          </svg>

          Читать отзыв полностью
        </button>
      </div>

      ${(data.video || data.socials)
        ? `<ul class="ui-text-review__contacts">
          ${data.video
            ? `<li class="ui-text-review__contact">
                ${UiButtonVanilla({
                  theme: 'stroke-secondary',
                  size: 'extra-small',
                  title: 'Видеоотзыв',
                  icon: 'ui-play-circle-dark',
                  classes: `ui-text-review__video-button ${data.video.classes}`,
                  attrs: `${data.video.attrs}`
                })}
              </li>`
            : ''
          }

          ${data.socials.map(({ name, link, icon }) => {
            return (
              icon
                ? `<li class="ui-text-review__contact">
                    ${UiButtonVanilla({
                      href: link,
                      theme: 'stroke-secondary',
                      size: 'extra-small',
                      title: name,
                      icon: `ui-${IconsName[icon] ?? icon}-filled`,
                      classes: 'ui-text-review__button',
                      attrs: 'target=_blank'
                    })}

                    ${UiIconButtonVanilla({
                      href: link,
                      theme: 'stroke-secondary',
                      size: 'extra-small',
                      shape: 'square',
                      icon: `ui-${IconsName[icon] ?? icon}-filled`,
                      ariaLabel: name,
                      classes: 'ui-text-review__button ui-text-review__button--mobile',
                      attrs: `data-social="${name}" target="_blank"`
                    })}
                  </li>`
                : `<li class="ui-text-review__contact">
                    ${UiButtonVanilla({
                      href: link,
                      theme: 'stroke-secondary',
                      size: 'extra-small',
                      title: name,
                      attrs: 'target=_blank'
                    })}
                  </li>`
              )
          }).join('')}
          </ul>`
        : ''}
    </article>`
  )
}

export const UiTextReviewTemplate = (
  {
    data = {},
    theme = 'white',
    classes = ''
  }
) => {
  return getUiTextReviewTemplate({ data, theme, classes })
}
